var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyProject = function SvgEmptyProject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 69,
    viewBox: "0 0 71 69",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0.385 0.257L58.635 0.257 58.635 57 0.385 57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M0 0.351L58.25 0.351 58.25 57.094 0 57.094z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(12 12.649)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M58.636 57l-1.305-.343c-8.263-2.176-17.898-3.325-27.86-3.325-9.926 0-19.533 1.143-27.783 3.306l-1.303.341.343-1.301c.857-3.26 1.563-6.762 2.095-10.408.065-.429.47-.721.892-.666.43.064.728.463.665.892-.472 3.231-1.078 6.351-1.805 9.294 8.083-1.984 17.348-3.031 26.896-3.031 9.583 0 18.874 1.053 26.972 3.05-2.002-8.102-3.057-17.403-3.057-26.996 0-8.936.924-17.683 2.675-25.393-3.034.733-6.256 1.342-9.597 1.809-.42.068-.827-.24-.887-.669-.06-.43.24-.827.67-.887 3.747-.526 7.34-1.229 10.677-2.089l1.269-.327-.31 1.274c-1.913 7.89-2.924 16.978-2.924 26.282 0 9.972 1.152 19.615 3.333 27.883L58.636 57z",
    mask: "url(#prefix__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(0 .649)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M29.086 51.853c9.583 0 18.873 1.053 26.972 3.05-2.001-8.103-3.056-17.404-3.056-26.995 0-8.936.923-17.681 2.674-25.394-8.012 1.94-17.173 2.96-26.59 2.96-9.386 0-18.52-1.016-26.512-2.94 1.748 7.708 2.669 16.449 2.669 25.373 0 9.583-1.053 18.88-3.052 26.978 8.083-1.985 17.347-3.032 26.895-3.032zm29.164 5.241l-1.304-.343c-8.263-2.175-17.898-3.325-27.86-3.325-9.927 0-19.534 1.143-27.783 3.307L0 57.075l.343-1.303C2.52 47.505 3.67 37.87 3.67 27.908c0-9.292-1.01-18.373-2.92-26.263L.44.375l1.27.324C9.869 2.795 19.335 3.9 29.086 3.9c9.782 0 19.276-1.113 27.453-3.222L57.808.35l-.31 1.274c-1.912 7.893-2.923 16.98-2.923 26.282 0 9.972 1.152 19.615 3.33 27.884l.345 1.303z",
    mask: "url(#prefix__d)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emptyProject.e5748432.svg";
export { ForwardRef as ReactComponent };